import React from 'react'
import styled from 'styled-components'
import {flex, colors} from '../styles'

const Form = styled.form`
  ${flex}
  max-width: 30rem;
  margin: 1.5rem auto;
`

const Input = styled.input`
  font-family: inherit;
  font-size: inherit;
  padding: 0 1rem;
  margin: 0;
  flex-grow: 1;
  border: 1px solid ${colors.pinkText};
  border-radius: 0;
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
  border-right: none;
  line-height: 3em;
  height: 3em;
  box-shadow: none;
`

const Button = styled.button`
  font-size: inherit;
  flex: 0 1 8rem;
  margin: 0;
  background: ${colors.pinkText};
  border: none;
  color: white;
  border-radius: 0;
  height: 3em;
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
  border: 1px solid #DA005C;
  border-left: none;
  cursor: pointer;
`

export default () => (
  <Form onClick={() => window.ga && window.ga('send', 'event', 'signupForm', 'submit')}
        action="https://gumroad.com/follow_from_embed_form" method="post">
    <Input name="seller_id" type="hidden" value="8905017409209"/>
    <Input required name="email" placeholder="Your email address" type="email"/>
    <Button type="submit">Subscribe</Button>
  </Form>
)



/** WEBPACK FOOTER **
 ** ./src/components/SignupForm.js
 **/